import type { IconData } from '@stacksjs/iconify-core'

export const iNursery: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M41.144 9.231a8.858 8.858 0 1 1-17.716 0a8.858 8.858 0 0 1 17.716 0m-8.873 27.373h-9.364v-6.76l-7.16 7.208c-3.235 3.236-7.621-.912-4.38-4.153l11.856-11.88c.962-.955 2.015-1.563 3.685-1.563h10.633c1.67 0 2.798.589 3.787 1.563l11.976 11.996c3.085 3.084-1.417 7.272-4.378 4.156l-7.348-7.365v6.797l-9.308.001zm9.268 3.507l-7.037 7.039l5.165 5.156l-5.293 5.294c-3.126 3.125 1.186 7.593 4.416 4.361l8.373-8.705c1.796-1.833 2.293-5.219.367-7.145c-.006-.008-5.992-6-5.992-6zm-18.63 0l7.038 7.039l-5.165 5.156l5.293 5.294c3.125 3.125-1.185 7.593-4.416 4.361l-8.372-8.704c-1.798-1.833-2.294-5.219-.367-7.145c.005-.009 5.991-6.001 5.991-6.001z\"/>",
  "width": 64,
  "height": 64,
  "viewBox": "0 0 64 64"
}

export default iNursery
